// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ql2L","content":"styles_content__73JZc","row":"styles_row__2xH8c","footer":"styles_footer__8LoyC","phraseLength":"styles_phraseLength__2ZJaA"};